<template>
  <div class="text-box-time">
    <div>{{ title }}</div>
    <div class="flex items-center justify-between">
      <flat-pickr
        class="w-32"
        :config.sync="configTimePicker"
        v-model="inputValue"
        :disabled="isDisabledInput"
      ></flat-pickr>
    </div>
  </div>
</template>

  <script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "M.TextBoxTime",
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    title: {
      type: String,
      required: false
    },
    value: { required: false },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      inputValue: null,
      configTimePicker: {
        enableTime: true,
        noCalendar: true,
        minuteIncrement: 1,
        time_24hr: true,
        minTime: "00:00",
        maxTime: "23:59",
        locale: Japanese,
        dateFormat: "H:i"
      },
    }
  },
  components: {
    flatPickr
  },
  computed: {
    isDisabledInput() {
      return false;
    }
  },
}
  </script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.text-box-time {
  .required {
    color: $aisea-red;
  }
}
</style>